import React, { FunctionComponent } from 'react'
import Modal from '../../modal'
import ModalClosingButton from '../../modal/ModalClosingButton'
import style from './e3dLogoutModal.css'
import { useTranslation } from 'react-i18next'

type Props = {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
}

const E3DLogoutModal: FunctionComponent<Props> = ({ isOpen, onClose, onConfirm }) => {
    const { t } = useTranslation()
    if (!isOpen) {
        return null
    }

    return (
        <Modal isVisible={true} onClose={onClose}>
            <>
                <ModalClosingButton onClick={onClose} className="modalClose" />
                <div className={style.container}>
                    <div className={style.header}>
                        <h2 className={style.title}>{t('e3d.logoutConfirmationTitle')}</h2>
                    </div>
                    <div className={style.content}>
                        <p className={style.message}>{t('e3d.logoutConfirmationMessage')}</p>
                        <div className={style.actions}>
                            <button className={`${style.button} ${style.buttonCancel}`} onClick={onClose}>
                                {t('e3d.cancel')}
                            </button>
                            <button className={`${style.button} ${style.buttonConfirm}`} onClick={onConfirm}>
                                {t('e3d.logout')}
                            </button>
                        </div>
                    </div>
                </div>
            </>
        </Modal>
    )
}

export default E3DLogoutModal
